import {
  Component,
  computed,
  ElementRef,
  EventEmitter,
  input,
  OnInit,
  Output,
  viewChild,
} from '@angular/core';

@Component({
  selector: 'app-back-button-box',
  template: `
    <span
      (click)="clicked.next()"
      class="outer-container flex items-center cursor-pointer"
      [class]="{
        'gap-2': hasContent(),
        'gap-0': !hasContent(),
        hovered: isHovered(),
      }"
    >
      <span class="arrow-left"></span>
      <span #projectedContentWrapper><ng-content></ng-content></span>
    </span>
  `,
  styleUrls: ['back-button-box.component.scss'],
})
export class BackButtonBoxComponent implements OnInit {
  // activates hover state styles if set to true.
  // useful when there is text next to it and you want to change styles on text hover.
  isHovered = input(false);
  @Output() clicked = new EventEmitter<void>();

  projectedContentWrapper = viewChild<ElementRef<any>>('projectedContentWrapper');

  hasContent = computed(() => {
    return this.projectedContentWrapper()?.nativeElement?.childNodes?.length > 0;
  });

  constructor() {}

  ngOnInit(): void {}
}
